import React from 'react';
import immutable from 'immutable';

import SavedSearchWidgetContainer from 'components/stateful/search/SavedSearchWidgetContainer';
import SearchWidgetsContainer from 'components/stateful/search/SearchWidgetsContainer';
import Sidebar from 'components/pure/utils/Sidebar';
import SearchTabActions from 'actions/search/SearchTabActions';
import CallActions from 'actions/CallActions';
import SearchInputActions from 'actions/search/SearchInputActions';

class SearchSidebar extends React.Component {
  constructor(props, context) {
    super(props, context);

    // Show "My Calls" tab if the user is more than "view_self"
    const myCallsSidebarMenuItem = {
      name: 'My Calls',
      url: '/calls/self',
    };

    let sidebarMenu = immutable.List([
      {
        name: 'All Calls',
        url: '/calls/my',
      },
    ]);

    // remove 'Team' menu item if the user lacks any of the required permissions
    const requiredPermissions = ['view_team', 'view_all_department', 'view_all_account'];
    const userPermissions = this.props.userPermissions;
    let hasPermission = false;
    if (userPermissions) {
      hasPermission = requiredPermissions.some(permission => {
        return userPermissions.includes(permission);
      });
    }
    if (hasPermission) {
      sidebarMenu = sidebarMenu.insert(1, myCallsSidebarMenuItem);
    }

    this.state = {
      sidebarMenu: sidebarMenu,
    };
  }

  /** Only when the user are switching between "All Calls" and "My Calls" should the search
   * fields be preserved / carried over
   * @param event Event object
   * @param linkName Name of the link clicked
   */
  onClickLink = (event, linkName) => {
    const currentTabLocation = window.location.pathname;
    if (
      (currentTabLocation === '/calls/self' && linkName === 'All Calls') ||
      (currentTabLocation === '/calls/my' && linkName === 'My Calls')
    ) {
      // Carry over search fields. Clear only Caller-related search field states
      SearchTabActions.switchWithMyCalls();
    } else {
      // Clear search fields in all the other cases
      CallActions.updateFileId(''); // TODO: Refactor this by removing the need to call it here
      this.clearSearchResults();
    }
  };

  /** Clear the current search results page and refresh */
  clearSearchResults() {
    SearchInputActions.clearSearchInputValue();
    CallActions.clearFieldsSearch();
  }

  render() {
    return (
      <Sidebar
        hideSidebar={this.props.hideSidebar}
        sidebarMenu={this.state.sidebarMenu}
        onClickLink={this.onClickLink}>
        <SavedSearchWidgetContainer searchTerm={this.props.searchTerm} />
        {(this.props.searchTerm || this.props.isAdvancedSearch) && (
          // The user is "in" a search
          <SearchWidgetsContainer widgetWhitelistKey={this.props.widgetWhitelistKey} />
        )}
      </Sidebar>
    );
  }
}

export default SearchSidebar;
